// extracted by mini-css-extract-plugin
module.exports = {"trustedBadge":"AHcp","trustedIcon":"AHcr","big":"AHct","tooltip":"AHcv","hidden":"AHb-","closeBtn":"AHcx"};